import Container from 'typedi';
import InvalidRouteTimeException from '../exceptions/InvalidRouteTimeException';
import NoActivitiesException from '../exceptions/NoActivitiesException';
import NoRouteException from '../exceptions/NoRouteException';
import NoTripsException from '../exceptions/NoTripsException';
import NoValidSpot from '../exceptions/NoValidSpot';
import InvalidAssignationException from '../exceptions/InvalidAssignationException';
import RouteRepository from '../repositories/RouteRepository';
import TripService from './TripService';

class RouteService {
  routeRepository;
  tripService;
  constructor() {
    this.routeRepository = Container.get(RouteRepository);
    this.tripService = Container.get(TripService);
  }
  getRoutes = async (page, rowsPerPage, filters) => await this.routeRepository.getRoutes(page, rowsPerPage, filters);
  getStatus = async () => await this.routeRepository.getStatus();
  deleteRoute = async (id) => await this.routeRepository.deleteRoute(id);
  getRoute = async (id) => await this.routeRepository.getRouteById(id);

  validateMassiveRouteUploadPreSubmission(routes) {
    if (routes.length === 0) {
      throw new NoRouteException('No routes to process');
    }

    var minDate = new Date();
    minDate.setDate(minDate.getDate() - 3);

    for (const route of routes) {
      if (new Date(route.startDate + ' ' + route.startTime).getTime() < minDate.getTime()) {
        throw new InvalidRouteTimeException("Route's start time is in the past", route.index);
      }
      if (!route.trips || !route.trips.length) {
        throw new NoTripsException('Route has no trips', route.index);
      } else {
        for (const trip of route.trips) {
          if (!trip.activities || !trip.activities.length) {
            throw new NoActivitiesException('Trip has no activities', route.index, trip.index);
          }
          if (trip.tripDestination === 'Crear nuevo destino' || trip.tripDestination === 'Create new destination') {
            let validate = trip.Street != '' && trip.City != '' && trip.State != '' && trip.Country != '';
            if (!validate) {
              throw new NoValidSpot('Sot not have the enough parameters', route.index);
            }
          }
          
          if ((trip.vehicle === undefined || trip.vehicle === null || trip.vehicle === "") && trip.operator != undefined && trip.operator != null && trip.operator != "") {
            throw new InvalidAssignationException('Viaje debe tener un vehículo para realizar asignacion', route.index, trip.index);
          }
          if ((trip.operator === undefined || trip.operator === null || trip.operator === "") && trip.vehicle != undefined && trip.vehicle != null && trip.vehicle != "") {
            throw new InvalidAssignationException('Viaje debe tener un conductor para realizar asignacion', route.index, trip.index);
          }
        }
      }
    }
    return true;
  }
  validateMassivePlanificationUploadPreSubmission(routes) {
    if (routes.length === 0) {
      throw new NoRouteException('No routes to process');
    }

    var minDate = new Date();
    minDate.setDate(minDate.getDate() - 3);

    for (const route of routes) {
      if (new Date(route.startDate + ' ' + route.startTime).getTime() < minDate.getTime()) {
        throw new InvalidRouteTimeException("Route's start time is in the past", route.index);
      }
      if (!route.trips || !route.trips.length) {
        throw new NoTripsException('Route has no trips', route.index);
      } else {
        for (const trip of route.trips) {
          if (trip.tripDestination === 'Crear nuevo destino' || trip.tripDestination === 'Create new destination') {
            let validate = trip.Street != '' && trip.City != '' && trip.State != '' && trip.Country != '';
            if (!validate) {
              throw new NoValidSpot('Sot not have the enough parameters', route.index);
            }
          }
        }
      }
    }
    return true;
  }
  processMassiveRouteSubmission(routes, spots, activityTypes, itemTypes, tags) {
    console.log('probando masivo', routes);
    const requestRoutes = [];
    routes.forEach((route) => {
      const originSpot = spots.find((s) => {
        //Verifico si el spot del listado es temporal
        if (s.type !== 'Temporal' && s.name === route.origin) {
          return s;
        }
        //Si es temporal entonces transformo el nombre del spot 
        else if (s.type === 'Temporal') {
          const splitAddress = s.name.split(',');
          const newName = `${splitAddress[0]}, ${splitAddress[1]}`;
          if (newName === route.origin) {
            return s;
          }
        }
      });
      const requestTrips = route.trips
        ? this.tripService.processMassiveTripSubmission(route.trips, spots, activityTypes, itemTypes, tags)
        : [];

      console.log('hora inicio', route.startDate);
      console.log('minuto inicio', route.startTime);
      const body = {
        origin: {
          id: originSpot.id,
        },
        startDate: new Date(route.startDate + ' ' + route.startTime + ':00').getTime(),
        loadTime: route.loadTime && String(route.loadTime) !== '' ? Math.round(Number(route.loadTime)) * 60 : 0,
        unloadTime: route.unloadTime && String(route.unloadTime) !== '' ? Math.round(Number(route.unloadTime)) * 60 : 0,
        name: route.name,
        trips: requestTrips,
      };
      requestRoutes.push(body);
    });

    return requestRoutes;
  }

  async sendMassiveRouteSubmission(requestBody) {
    return this.routeRepository.sendMassiveRouteSubmission(requestBody);
  }

  async submitMassiveRoutes(routes, spots, activityTypes, itemTypes, tags) {
    const requestRoutes = this.processMassiveRouteSubmission(routes, spots, activityTypes, itemTypes, tags);
    return this.sendMassiveRouteSubmission(requestRoutes);
  }
}

Container.set({ id: RouteService, type: RouteService });

export default RouteService;
